<template>
    <div class="flex items-center gap-1">
        <Icon
            name="arrow-rotate"
            class="w-3 h-3 text-gray-500"
        />
        <span
            class="cursor-auto text-sm text-gray-800"
            @click.stop
        >
            {{ numberOfScheduledMeetings }} meetings
        </span>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        numberOfScheduledMeetings: {
            type: Number,
            required: true,
        },
    })
</script>
